module.exports = __webpack_public_path__ + "img/bg_teacher_training_camp@2x.3ed38c3d.png";